/**
 * created by lei lei on 2020/5/30
 */
import React, {Component} from 'react';
import {Row, Col, Button} from 'antd';
import {getCurrentUser} from "../../../../actions";

export default class Head extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            name : "",
            titleStr : "",
            photoUrl : "images/header_boys.png",
        }
    }

    componentWillMount() {
    }

    componentDidMount()
    {
        let now = new Date();
        let hour = now.getHours();
        let dateStr = "早上好";
        if(hour < 6){dateStr="凌晨好";}
        else if (hour < 9){dateStr="早上好"}
        else if (hour < 12){dateStr="上午好"}
        else if (hour < 14){dateStr="中午好"}
        else if (hour < 17){dateStr="下午好"}
        else if (hour < 19){dateStr="傍晚好"}
        else if (hour < 22){dateStr="晚上好"}
        else {dateStr="夜里好"}

        getCurrentUser((currentUser)=>{
            this.setState({
                name : currentUser.name,
                titleStr : dateStr,
                photoUrl : currentUser.photoUrl===""?"images/header_boys.png":currentUser.photoUrl,
            })
        });
    }

    render() {
        return (
            <div style={{width: '100%',borderTop:'1px solid #ebebeb'}}>
                <div style={{background: '#FFFFFF', }}>
                    <div style={{fontSize: 20, fontWeight: 'bold',marginLeft:20}}>工作台</div>
                    <Row>
                        <Col span={2}>
                            <div style={{width: 80, height: 80, lineHeight: '80px', marginLeft:20, marginBottom:10}}>
                                <img style={{width: 80, height: 80, borderRadius: '50%'}} src={this.state.photoUrl} alt=""/>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={{fontSize: 20,}}>{this.state.titleStr}，{this.state.name}，祝您开心每一天！</div>
                            {/*<div style={{fontSize: 14, marginTop: 25}}>总编辑 | 宣传部－新媒体运营组</div>*/}
                        </Col>
                       {/* <Col span={10} style={{textAlign:"right",paddingRight:"20px"}}>
                            <Button type="primary" onClick={() => {
                                window.location.hash = '/topicSelect/topicSelect'
                            }}>报送选题</Button>
                            <Button type="primary" onClick={() => {
                                window.location.hash = '/topicSelectManager/topicSelectManager'
                            }} style={{marginLeft: 20}}>选题管理</Button>
                            <Button type="primary" onClick={() => {
                                window.location.hash = '/interviewTask/interviewTask/1'
                            }} style={{marginLeft: 20}}>新建单独活动</Button>
                            <Button type="primary" onClick={() => {
                                window.location.hash = '/interviewTask/interviewTask/2'
                            }} style={{marginLeft: 20}}>新建选题报道</Button>

                        </Col>*/}
                    </Row>
                </div>

            </div>
        )
    }
}